/** Where to send the user after a successful sign in / registration. */
export function consumeIntendedPath(fallback = '/dashboard') {
  try {
    const intendedPath = localStorage.getItem('intendedPath');
    localStorage.removeItem('intendedPath');
    if (intendedPath && intendedPath.startsWith('/') && !intendedPath.startsWith('/login') && !intendedPath.startsWith('/register')) {
      return intendedPath;
    }
  } catch (error) {
    // storage unavailable
  }
  return fallback;
}

/** Human readable Firebase auth errors. */
export function authErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const code = error?.code || '';
  switch (code) {
    case 'auth/invalid-email':
      return 'That email address is not valid.';
    case 'auth/user-disabled':
      return 'This account has been disabled.';
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Invalid email or password.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a moment and try again.';
    case 'auth/email-already-in-use':
      return 'An account with this email already exists. Try signing in instead.';
    case 'auth/weak-password':
      return 'Password must be at least 6 characters.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return 'The Google sign-in window was closed before finishing.';
    case 'auth/popup-blocked':
      return 'Your browser blocked the sign-in popup. Allow popups and try again.';
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.';
    default:
      return fallback;
  }
}
